import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import NotFound from '../containers/NotFound';
import isLoggedIn from '../utils/index';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import { loadCollageOrganizations } from '../actions';
import HomeCollage from '../components/HomeCollage';


class FlatPage extends React.Component {
  state = {
    page: {
      id: null,
      url: null,
      title: null,
      content: null,
      seo_title: null,
      seo_description: null
    },
    notFound: false
  };
  constructor(props) {
    super(props);
  }

  getPage = (url) => {
  };

  setPageOrNotFound = (url) => {
    if (this.props.flatPages.isLoading) {
      return;
    }

    let nullPage = {
      id: null,
      url: null,
      title: null,
      content: null,
      seo_title: null,
      seo_description: null
    };

    let page = null;

    let match = this.props.flatPages.pages.filter(page => page.url.indexOf(url) != -1);
    if(match.length == 1) {
      page = match[0];
    }

    if (page) {
      this.setState({
        page,
        notFound: false
      });
      if (typeof(window) !== "undefined") {
        window.scrollTo(0,0)
      }
    } else {
      this.setState({
        page: nullPage,
        notFound: true
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if(nextProps.params.splat != this.state.url) {
      this.setPageOrNotFound(nextProps.params.splat);
    }
  }

  componentWillMount() {
    this.setPageOrNotFound(this.props.params.splat);
  }

  createContentMarkup = () => {
    return { __html: this.state.page.content };
  };

  render() {

    if (this.props.flatPages.isLoading) {
      return <span />;
    }

    if (this.state.notFound) {
      return <NotFound />;
    }

    const meta = {
        title: 'WorldWideWomen | ' + String(this.state.page.seo_title || this.state.page.title),
        description: this.state.page.seo_description
    }

    let joinButton = <Link to="/join" className="fp-join-us" >join us!</Link>;
    if(isLoggedIn(this.props.auth.user)) {
      joinButton = '';
    }

    let fpTagLineClass = '';

    let bannerCollageImage = '';



    let bannerCopy = '';
    if (this.props.router.location.pathname == "/pages/partner-with-us") {
      fpTagLineClass = 'fp-tagline fp-tagline-long';
      bannerCopy = <h3>the global resource center for women&hellip; partner with us</h3>
    } else {
      fpTagLineClass = 'fp-tagline';
      bannerCopy = <h3>the global resource center for women&hellip; {joinButton}</h3>
    }

    // Default banner image
    bannerCollageImage = <div className="fp-banner">
      <div className={fpTagLineClass}>
        {bannerCopy}
      </div>
    </div>

    // Define banner image height for meet the team page
    let currentpath = this.props.router.location.pathname;
    // get current page width
    let currentWidth = window.innerWidth;
    let bannerHeight = 0;
    let bannerHeightString = '';
    if ((currentpath == "/pages/meet-the-team") && (currentWidth < 831)) {
      
      bannerHeight = currentWidth;
      bannerHeightString = bannerHeight.toString() + "px";
      bannerCollageImage = <div className="fp-banner" style={{height: bannerHeightString}}>
        <div className={fpTagLineClass}>
          {bannerCopy}
        </div>
      </div>
    } else {
      bannerCollageImage = <div className="fp-banner">
        <div className={fpTagLineClass}>
          {bannerCopy}
        </div>
      </div>
    }



    // Swap in dynamic collage, (aka HomeCollage.jsx) for
    // specific pages


    let buttonCollage = <Link style={{marginTop: '10px'}} to="/join" className="home-collageJoinUs">Join us</Link>;

    if(isLoggedIn(this.props.auth.user)) {
      buttonCollage = '';
    }




    return (
      <div className="content-wrapper">
        <DocumentMeta {...meta} />
        <div className="flatpage-inner">

          <div className="flat-page-wrapper">

            {bannerCollageImage}


            <div className="fp-page-title-wrapper">{ this.state.page.title }</div>

            <div className="fp-content-wrapper">

              <div className="flatpage-content" dangerouslySetInnerHTML={this.createContentMarkup()}></div>

            </div>


          </div>


        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, { push, loadCollageOrganizations })(FlatPage);



// WEBPACK FOOTER //
// ./src/containers/FlatPage.jsx